import { shippingCarriers } from './shippingCarriers';

type ShippingTrackerLike = {
  components?: {
    trackingNumber?: unknown;
    carrierId?: unknown;
    additionalDetails?: {
      easypost?: {
        publicUrl?: unknown;
      };
    };
  };
};

/**
 * Resolves a single public tracking page URL for a shipping tracker cell value, if one exists.
 * Prefers EasyPost public URL from synced data, otherwise uses the carrier's tracking URL template.
 * Plain string values (tracking number only) have no carrier context — returns null.
 */
export function resolveTrackingUrlForShippingValue(value: unknown): string | null {
  if (value == null) return null;
  if (typeof value === 'string') {
    return null;
  }
  if (typeof value !== 'object' || Array.isArray(value)) return null;
  const tracker = value as ShippingTrackerLike;
  const components = tracker.components;
  if (!components) {
    return null;
  }
  const trackingNumber =
    typeof components.trackingNumber === 'string' ? components.trackingNumber.trim() : '';
  if (!trackingNumber) return null;

  const publicUrl = components.additionalDetails?.easypost?.publicUrl;
  if (typeof publicUrl === 'string') {
    const u = publicUrl.trim();
    if (u.startsWith('https://') || u.startsWith('http://')) {
      return u;
    }
  }

  const carrierId =
    typeof components.carrierId === 'string' && components.carrierId.trim() ? components.carrierId : 'other';
  const carrier =
    shippingCarriers.find((x) => x.id === carrierId) ||
    shippingCarriers.find((x) => x.id === 'other');
  const template = carrier?.trackingUrlTemplate;
  if (!template) return null;
  return template.replace('{trackingNumber}', trackingNumber);
}
